{
  "add": "Agregar",
  "edit": "Editar",
  "delete": "Eliminar",
  "save": "Guardar",
  "cancel": "Cancelar",
  "close": "Cerrar",
  "confirm": "Confirmar",
  "done": "Listo",
  "search": "Buscar...",
  "searchPlaceholder": "Buscar...",
  "filter": "Filtrar",
  "clear": "Limpiar",
  "loading": "Cargando...",
  "error": "Error",
  "success": "Éxito",
  "warning": "Advertencia",
  "info": "Información",
  "yes": "Sí",
  "no": "No",
  "ok": "OK",
  "back": "Atrás",
  "brandWordmark": "Homy",
  "backToHome": "Volver a HomyOS",
  "next": "Siguiente",
  "previous": "Anterior",
  "submit": "Enviar",
  "saving": "Guardando...",
  "change": "Cambiar",
  "inactive": "Inactivo",
  "reset": "Restablecer",
  "select": "Seleccionar",
  "selected": "Seleccionado",
  "all": "Todos",
  "none": "Ninguno",
  "export": "Exportar",
  "general": "General",
  "or": "o",
  "actions": {
    "title": "Acciones",
    "save": "Guardar",
    "cancel": "Cancelar",
    "edit": "Editar",
    "delete": "Eliminar",
    "close": "Cerrar",
    "confirm": "Confirmar",
    "back": "Volver",
    "next": "Siguiente",
    "view": "Ver",
    "filter": "Filtrar",
    "reset": "Restablecer",
    "create": "Crear",
    "add": "Agregar",
    "done": "Listo",
    "submit": "Enviar"
  },
  "state": {
    "loading": "Cargando...",
    "saving": "Guardando...",
    "submitting": "Enviando...",
    "processing": "Procesando..."
  },
  "saveFailed": "Error al guardar",
  "details": "Detalles",
  "contextualHelp": {
    "trigger": "Ayuda y orientación",
    "openHelp": "Abrir ayuda",
    "closeHelp": "Cerrar ayuda",
    "needMoreHelp": "¿Necesitas más ayuda? Visita el Centro de Ayuda"
  },
  "view": "Ver",
  "copy": "Copiar",
  "copied": "¡Enlace copiado!",
  "clickToCopy": "Toca para copiar",
  "copyFailed": "No se pudo copiar el enlace",
  "share": "Compartir",
  "toast": {
    "copyErrorDetails": "Copiar detalles del error",
    "copied": "Copiado"
  },
  "download": "Descargar",
  "upload": "Subir",
  "remove": "Quitar",
  "create": "Crear",
  "update": "Actualizar",
  "name": "Nombre",
  "email": "Correo electrónico",
  "phone": "Teléfono",
  "call": "Llamar",
  "address": "Dirección",
  "date": "Fecha",
  "pickDate": "Elegir fecha",
  "monthsShort": [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic"
  ],
  "time": "Hora",
  "status": {
    "title": "Estado",
    "active": "Activo",
    "inactive": "Inactivo",
    "pending": "Pendiente",
    "draft": "Borrador",
    "archived": "Archivado"
  },
  "type": "Tipo",
  "description": "Descripción",
  "required": "Requerido",
  "optional": "Opcional",
  "unassigned": "Sin asignar",
  "nav": {
    "dashboard": "Panel de Control",
    "inbox": "Bandeja",
    "listings": "Publicaciones",
    "properties": "Propiedades",
    "visits": "Visitas",
    "bookings": "Reservas",
    "availability": "Disponibilidad",
    "eventTypes": "Tipos de evento",
    "applications": "Aplicaciones",
    "rentals": "Alquileres",
    "pipelines": "Workflows",
    "workflows": "Workflows",
    "calendar": "Calendario",
    "maintenance": "Mantenimiento",
    "vendorCockpit": "Mi Panel",
    "maintenanceRequests": "Solicitudes",
    "projects": "Proyectos",
    "standingServices": "Servicios Recurrentes",
    "vendors": "Proveedores",
    "marketplace": "Marketplace",
    "vendorStatements": "Declaraciones",
    "support": "Soporte",
    "residentSupport": "Soporte",
    "orgSupport": "Cola de Soporte",
    "helpCenter": "Centro de Ayuda",
    "tasks": "Tareas",
    "databases": "Bases de datos",
    "organizations": "Organización",
    "issues": "Incidencias",
    "landingPage": "Página de inicio",
    "trust": "Confianza y Verificación",
    "settings": "Configuración",
    "tenantLease": "Mi Alquiler",
    "tenantPayments": "Pagos",
    "toggleGroup": "Mostrar u ocultar sección {{group}}",
    "openGroup": "Abrir menú de {{group}}",
    "mainNavigation": "Navegación principal",
    "group": {
      "portfolioMarketing": "Cartera y marketing",
      "leasing": "Arrendamiento",
      "schedule": "Agenda",
      "maintenance": "Mantenimiento",
      "workComms": "Trabajo y comunicaciones",
      "dataOrg": "Datos y organización"
    },
    "documents": "Documentos"
  },
  "organization": {
    "fallback": "Organización",
    "manage": "Administrar organización",
    "switch": "Cambiar organización"
  },
  "viewAll": "Ver Todo",
  "expandSidebar": "Expandir barra lateral",
  "collapseSidebar": "Colapsar barra lateral",
  "collapse": "Contraer",
  "openMenu": "Abrir menú",
  "toggleTheme": "Cambiar tema",
  "theme": {
    "toggle": "Cambiar tema",
    "light": "Claro",
    "dark": "Oscuro",
    "system": "Sistema"
  },
  "changeLanguage": "Cambiar idioma",
  "morePages": "Más páginas",
  "notifications": "Notificaciones",
  "platformConsole": "Consola de Plataforma",
  "userFallback": "Usuario HomyOS",
  "roleFallback": "Administrador",
  "userMenu": {
    "openMenu": "Abrir menú de cuenta",
    "profile": "Perfil y preferencias",
    "organization": "Organización",
    "security": "Seguridad"
  },
  "logout": "Cerrar sesión",
  "visits": {
    "title": "Visitas",
    "upcomingTitle": "Próximas visitas",
    "upcomingVisits": "Próximas visitas",
    "availability": "Disponibilidad",
    "empty": "No hay visitas programadas.",
    "failedToLoad": "Error al cargar visitas",
    "failedToUpdate": "Error al actualizar visita",
    "property": "Propiedad",
    "date": "Fecha",
    "status": "Estado",
    "confirm": "Confirmar",
    "cancel": "Cancelar visita",
    "markNoShow": "Marcar ausencia",
    "visitor": "Visitante",
    "configureAvailability": "Configurar",
    "sameHoursEveryDay": "Mismos horarios todos los días",
    "whichDays": "¿Qué días?",
    "whatHours": "¿Qué horarios?",
    "to": "a",
    "howLongEachVisit": "¿Cuánto dura cada visita?",
    "slotsPerDay": "{{count}} turnos/día",
    "slotsPerWeek": "{{count}} turnos/semana",
    "minVisits": "{{count}} min visitas",
    "noAvailability": "Sin disponibilidad configurada",
    "saveAvailability": "Guardar disponibilidad",
    "availabilitySaved": "Disponibilidad guardada",
    "failedToSave": "Error al guardar disponibilidad",
    "minuteAbbrev": "min",
    "yourSchedule": "Tu Horario",
    "yourScheduleDescription": "Configura tu disponibilidad general para visitas",
    "perProperty": "Por Propiedad",
    "usingDefault": "Usando tu horario",
    "custom": "Personalizado",
    "applyToAll": "Aplicar a todas",
    "applyToAllConfirm": "Esto reemplazará la disponibilidad de todas las propiedades con tu horario general. ¿Continuar?",
    "saveSchedule": "Guardar Horario",
    "scheduleSaved": "Horario guardado",
    "failedToSaveSchedule": "Error al guardar horario"
  },
  "errorBoundary": {
    "title": "Algo salió mal",
    "message": "Ocurrió un error inesperado. Intenta actualizar la página o volver al inicio.",
    "refresh": "Actualizar página",
    "goHome": "Ir al inicio"
  },
  "notFound": {
    "code": "Error 404",
    "title": "Página no encontrada",
    "description": "La página que buscas no existe, ha sido eliminada o se movió a otra dirección.",
    "returnHome": "Volver al Panel"
  },
  "apiError": {
    "default": "Algo salió mal. Intenta de nuevo.",
    "network": "Error de conexión. Verifica tu red e intenta de nuevo."
  },
  "dataTable": {
    "rowsPerPage": "Por página",
    "showing": "Mostrando {{start}}–{{end}} de {{total}}",
    "sortAscending": "Orden ascendente",
    "sortDescending": "Orden descendente",
    "clearSort": "Quitar orden",
    "noResults": "Sin resultados."
  },
  "dateRangePicker": {
    "placeholder": "Seleccionar rango de fechas",
    "clear": "Limpiar rango de fechas",
    "presets": {
      "today": "Hoy",
      "last7": "Últimos 7 días",
      "last30": "Últimos 30 días",
      "mtd": "Mes a la fecha",
      "ytd": "Año a la fecha"
    }
  },
  "list": {
    "filters": {
      "title": "Filtros",
      "active": "activos",
      "clearAll": "Limpiar filtros",
      "removeFilter": "Quitar {{filter}}",
      "dateRange": "Rango de fechas",
      "selectDateRange": "Filtrar por rango de fechas"
    },
    "viewMode": {
      "label": "Modo de vista",
      "table": "Tabla",
      "thumbnails": "Tarjetas",
      "grid": "Cuadrícula",
      "list": "Lista",
      "map": "Mapa",
      "kanban": "Kanban",
      "split": "Dividido"
    },
    "map": {
      "missingKeyTitle": "Mapa no disponible",
      "missingKeyDescription": "Configura VITE_GOOGLE_MAPS_API_KEY para habilitar la vista de mapa.",
      "loadFailedTitle": "Error al cargar el mapa",
      "loadFailedDescription": "Verifica tu conexión e intenta de nuevo.",
      "noLocationsTitle": "Sin ubicaciones",
      "noLocationsDescription": "Ningún elemento tiene coordenadas para mostrar en el mapa."
    }
  },
  "profile": "Perfil",
  "settings": "Configuración",
  "approvals": {
    "title": "Aprobaciones",
    "history": "Historial de aprobaciones",
    "pending": "Aprobaciones pendientes",
    "noPending": "No se encontraron aprobaciones pendientes.",
    "noHistory": "No hay registros de aprobación para este elemento.",
    "status": {
      "PENDING": "Pendiente",
      "APPROVED": "Aprobado",
      "REJECTED": "Rechazado",
      "CANCELLED": "Cancelado",
      "EXPIRED": "Expirado",
      "NEEDS_CLARIFICATION": "Requiere aclaración"
    },
    "strategy": {
      "SINGLE": "Aprobador único",
      "ANY_OF": "Cualquier aprobador",
      "ALL_OF": "Todos los aprobadores",
      "SEQUENTIAL": "Secuencial"
    },
    "actions": {
      "approve": "Aprobar",
      "reject": "Rechazar",
      "cancel": "Cancelar solicitud",
      "review": "Revisar",
      "submitting": "Enviando..."
    },
    "dialog": {
      "approveTitle": "Aprobar solicitud",
      "rejectTitle": "Rechazar solicitud",
      "cancelTitle": "Cancelar solicitud de aprobación",
      "notesLabel": "Notas de revisión",
      "notesPlaceholder": "Agregue comentarios o justificación (opcional)...",
      "reasonLabel": "Motivo de cancelación",
      "reasonPlaceholder": "Explique por qué se cancela esta solicitud...",
      "confirmApprove": "Confirmar aprobación",
      "confirmReject": "Confirmar rechazo",
      "confirmCancel": "Confirmar cancelación"
    },
    "step": "Paso {{order}}",
    "request": "Solicitud",
    "requestedBy": "Solicitado por",
    "assignedTo": "Asignado a",
    "resolvedBy": "Resuelto por",
    "requestedAt": "Solicitado el",
    "resolvedAt": "Resuelto el",
    "notes": "Notas",
    "entityType": "Entidad",
    "approvalType": "Tipo de aprobación"
  },
  "unsavedChanges": {
    "title": "¿Descartar cambios?",
    "description": "Los cambios sin guardar se perderán al cerrar el panel.",
    "keepEditing": "Seguir editando",
    "discard": "Descartar cambios"
  },
  "security": {
    "restricted": "Restringido",
    "masked": {
      "restrictedValue": "••••••",
      "restrictedTooltip": "Información financiera restringida"
    },
    "lockedMetricTooltip": "Esta métrica financiera está restringida por la política de la organización.",
    "unauthorized": {
      "title": "Acceso Restringido",
      "description": "No tiene permiso para ver este contenido."
    }
  },
  "retry": "Reintentar",
  "brandLogoAlt": "HomyOS",
  "brandOs": "OS",
  "clearSearch": "Limpiar búsqueda",
  "more": "Más",
  "progress": "Progreso",
  "created": "Creado",
  "statusLabel": "Estado",
  "id": "ID",
  "filters": {
    "primaryStateFilters": "Filtros de estado principales"
  },
  "impersonation": {
    "activeAria": "Impersonación diagnóstica activa",
    "badgeTitle": "Impersonación diagnóstica",
    "badge": "Impersonado",
    "viewingAs": "Viendo como",
    "in": "en",
    "readOnlyGuard": "Protección de solo lectura activa",
    "writeAllowed": "Escritura permitida",
    "ttl": "30m TTL",
    "operator": "Operador:",
    "endSession": "Finalizar sesión de diagnóstico",
    "exit": "Salir de impersonación"
  },
  "countryOptions": {
    "chile": "Chile (CLP / UF)",
    "argentina": "Argentina (ARS / USD)",
    "unitedStates": "Estados Unidos (USD)",
    "mexico": "México (MXN)",
    "brazil": "Brasil (BRL)",
    "colombia": "Colombia (COP)",
    "spain": "España (EUR)",
    "portugal": "Portugal (EUR)"
  },
  "landingPagePreview": "Vista previa de la página",
  "landingPagePreviewError": "No se pudo cargar la vista previa",
  "views": {
    "switcher": "Cambiar vista de aplicación",
    "operations": "Operaciones",
    "resident": "Residente",
    "contractor": "Contratista"
  },
  "fileDropzone": {
    "promptTitle": "Arrastra y suelta el archivo aquí",
    "promptSubtitle": "Admite PDF e imágenes de hasta {{maxSizeMB}}MB",
    "browse": "Explorar archivos",
    "uploading": "Subiendo...",
    "ready": "Listo",
    "failed": "Error",
    "preview": "Vista previa",
    "download": "Descargar",
    "remove": "Eliminar archivo",
    "close": "Cerrar",
    "empty": "No hay archivos adjuntos",
    "previewUnavailable": "La vista previa en línea no está disponible para este archivo."
  },
  "notificationPopover": {
    "title": "Notificaciones",
    "markAllRead": "Marcar todo como leído",
    "markRead": "Marcar como leído",
    "all": "Todas",
    "unread": "No leídas",
    "emptyTitle": "Todo al día",
    "emptyUnread": "No hay notificaciones sin leer",
    "emptyAll": "No hay notificaciones recientes",
    "viewAll": "Ver todo en Bandeja de Entrada"
  },
  "auditTimeline": {
    "today": "Hoy",
    "yesterday": "Ayer",
    "activity": "Registro de auditoría",
    "eventSingular": "{{count}} evento",
    "eventPlural": "{{count}} eventos",
    "emptyTitle": "Sin eventos de auditoría registrados",
    "emptySubtitle": "Los hitos de auditoría y eventos aparecerán aquí."
  },
  "editableCell": {
    "save": "Guardar (Enter)",
    "cancel": "Cancelar (Esc)",
    "invalidValue": "Valor inválido",
    "saveError": "Error al guardar",
    "selectPlaceholder": "Seleccionar..."
  }
}
